import React from 'react';
import { useLocation } from 'react-router-dom';

// Catches a render crash in a page so the visitor gets a message and a way
// out instead of a blank white screen. The real error still goes to the
// console (with the component stack) so it can be reported and fixed.
class Boundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error, info) {
        console.error('Page crashed:', error, info && info.componentStack);
    }

    render() {
        if (!this.state.error) return this.props.children;
        return (
            <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
                <div style={{ maxWidth: 420, textAlign: 'center' }}>
                    <h3 className="heading-font" style={{ marginBottom: 8 }}>Não foi possível mostrar esta página</h3>
                    <p style={{ color: '#666', marginBottom: 20 }}>
                        Ocorreu um erro inesperado. Tente recarregar a página.
                        Se usar a tradução automática do navegador, desative-a e tente novamente.
                    </p>
                    <button className="om-button" style={{ marginRight: 8 }} onClick={() => window.location.reload()}>Recarregar</button>
                    <a className="om-button" href="/" style={{ background: '#444' }}>Página inicial</a>
                </div>
            </div>
        );
    }
}

// keyed by path: moving to another page clears a previous crash
const ErrorBoundary = ({ children }) => {
    const location = useLocation();
    return <Boundary key={location.pathname}>{children}</Boundary>;
};

export default ErrorBoundary;
